import PreviewFile from './PreviewFile'

export default PreviewFile
